import type { ReactNode } from 'react';

export interface CommandBarTypedItemProps {
	type?: string;
	name: ReactNode;
	children?: ReactNode;
}

export function CommandBarTypedItem({ type, name, children }: CommandBarTypedItemProps) {
	return (
		<div className='flex flex-wrap items-center gap-2 text-lg font-medium'>
			{type && <span className='shrink-0 font-normal opacity-40'>{type}</span>}
			<span>{name}</span>
			{children}
		</div>
	);
}
